export default class Anchor {
    private static readonly SCROLL_TARGET_KEY = 'scrollTarget';
    private static readonly ACTIVE_CLASS = 'is-active';

    static init(): void {
        const anchors = document.querySelectorAll<HTMLElement>('[data-nav-anchor]');

        if (anchors.length === 0) {
            return;
        }

        anchors.forEach((anchor) => {
            anchor.addEventListener('click', (e: Event) => {
                e.preventDefault();

                const targetId = anchor.getAttribute('data-nav-anchor');

                if (!targetId) {
                    return;
                }

                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    // Section exists on current page - scroll to it
                    this.scrollToElement(targetElement);
                } else {
                    // Section doesn't exist - save ID to sessionStorage and redirect
                    sessionStorage.setItem(this.SCROLL_TARGET_KEY, targetId);
                    window.location.href = '/';
                }
            });
        });

        // After page load, check sessionStorage
        this.handleScrollTarget();

        // Initialize scroll tracking for active sections
        this.initScrollTracking();
    }

    private static scrollToElement(targetElement: HTMLElement): void {
        const fixedNav = document.querySelector<HTMLElement>('.base-nav');
        const navHeight = fixedNav ? fixedNav.offsetHeight : 0;

        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - navHeight;

        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth',
        });
    }

    private static handleScrollTarget(): void {
        const targetId = sessionStorage.getItem(this.SCROLL_TARGET_KEY);

        if (targetId) {
            // Remove value from sessionStorage
            sessionStorage.removeItem(this.SCROLL_TARGET_KEY);

            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                // Wait for DOM to fully render
                setTimeout(() => {
                    this.scrollToElement(targetElement);
                }, 100);
            }
        }
    }

    private static initScrollTracking(): void {
        // Update active section on scroll
        window.addEventListener('scroll', () => {
            this.updateActiveSection();
        });

        // Update on page load
        this.updateActiveSection();
    }

    private static updateActiveSection(): void {
        const anchors = document.querySelectorAll<HTMLElement>('[data-nav-anchor]');
        const fixedNav = document.querySelector<HTMLElement>('.base-nav');
        const navHeight = fixedNav ? fixedNav.offsetHeight : 0;

        // Offset for detection (top edge of window + navigation height + small buffer)
        const scrollOffset = window.pageYOffset + navHeight + 10;

        let currentSectionId: string | null = null;

        // Go through all sections and find the one currently visible
        anchors.forEach((anchor) => {
            const targetId = anchor.getAttribute('data-nav-anchor');

            if (!targetId) {
                return;
            }

            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                const sectionTop = targetElement.offsetTop;
                const sectionBottom = sectionTop + targetElement.offsetHeight;

                // Check if scroll position is within this section
                if (scrollOffset >= sectionTop && scrollOffset < sectionBottom) {
                    currentSectionId = targetId;
                }
            }
        });

        // Update classes on anchors
        anchors.forEach((anchor) => {
            const targetId = anchor.getAttribute('data-nav-anchor');

            if (targetId === currentSectionId) {
                anchor.classList.add(this.ACTIVE_CLASS);
            } else {
                anchor.classList.remove(this.ACTIVE_CLASS);
            }
        });
    }
}
